import React, { createContext, useContext, useState, useCallback } from 'react';

const SoftphoneContext = createContext();

export const SoftphoneProvider = ({ children }) => {
    const [minimized, setMinimized] = useState(true);
    const [status, setStatus] = useState('disconnected');
    const [inCall, setInCall] = useState(false);
    const [isCalling, setIsCalling] = useState(false);
    const [isRinging, setIsRinging] = useState(false);
    const [externalNumber, setExternalNumber] = useState(null);
    const [callOptions, setCallOptions] = useState({});

    const makeCall = useCallback((number, options = {}) => {
        setExternalNumber(number);
        setCallOptions(options);
        setMinimized(false);
    }, []);

    const value = {
        minimized,
        setMinimized,
        status,
        setStatus,
        inCall,
        setInCall,
        isCalling,
        setIsCalling,
        isRinging,
        setIsRinging,
        externalNumber,
        setExternalNumber,
        callOptions,
        makeCall
    };

    return (
        <SoftphoneContext.Provider value={value}>
            {children}
        </SoftphoneContext.Provider>
    );
};

export const useSoftphone = () => {
    const context = useContext(SoftphoneContext);
    if (!context) {
        throw new Error('useSoftphone must be used within a SoftphoneProvider');
    }
    return context;
};
